import { IFunciona } from "@edp-components/edp-card-widgets/edp-widget-funciona/funciona-service-type.model";
import { Contract } from "@edp-components/edp-contract";
import { IAssistanceActivities } from "@edp-models/funciona.model";
import { EdpUser } from "@edp-models/user.model";
import { Action } from "@ngrx/store";

export enum ETechnicalAssistancesActions {
    GetTechnicalAssistances         = "[TechnicalAssistance] Get Technical Assistance",
    SetTechnicalAssistances         = "[TechnicalAssistance] Set Technical Assistance",
    TechnicalAssistancesAPIError    = "[TechnicalAssistance] Set Technical Assistance API error",
}

export class GetTechnicalAssistances implements Action {
    public readonly type = ETechnicalAssistancesActions.GetTechnicalAssistances;
    constructor(public user: EdpUser, public contract: Contract, public funciona: IFunciona) { }
}

export class SetTechnicalAssistances implements Action {
    public readonly type = ETechnicalAssistancesActions.SetTechnicalAssistances;
    constructor(public payload: IAssistanceActivities) {}
}

export class TechnicalAssistancesAPIError implements Action {
    public readonly type = ETechnicalAssistancesActions.TechnicalAssistancesAPIError;
    constructor(public error: Error) {}
}

export type TechnicalAssistancesActions =
    GetTechnicalAssistances |
    SetTechnicalAssistances |
    TechnicalAssistancesAPIError;
